import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

/* Pages */
import NotFound from './pages/NotFound';
import SignIn from './pages/Auth/SignIn';
import SignUp from './pages/Auth/SignUp';
import Dashboard from './pages/Dashboard/Dashboard';
import UserCategoryThreads from './pages/Dashboard/UserCategoryThreads';
import VerifyAccount from './pages/Auth/VerifyAccount';
import EmailVerified from './pages/Auth/EmailVerified';
import ForgotPassword from './pages/Auth/ForgotPassword';
import UpdatePassword from './pages/Auth/UpdatePassword';

/* Admin Dashboard */
import AdminProtectedRoute from './components/AdminProtectedRoute';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import AdminCoachingCategories from './pages/AdminDashboard/AdminCoachingCategories';
import AdminCommonQuestions from './pages/AdminDashboard/AdminCommonQuestions';
import AdminAriInstructions from './pages/AdminDashboard/AdminAriInstructions';
import AdminLists from './pages/AdminDashboard/AdminLists';
import AdminSubscribers from './pages/AdminDashboard/AdminSubscribers';
import CategoryQuestGenerator from './pages/Dashboard/CategoryQuestGenerator';

/* CSS */
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import './assets/css/styles.css';
import './assets/css/grid.css';
import './assets/css/themes/ari-theme.css';
import './assets/css/themes/dark-mode.css';
import './assets/css/themes/light-mode.css';
import './assets/css/responsive.css';

function App() {
    return (
        <>
            <Router>
                <AuthProvider>
                    <div className="App">
                        <Routes>
                            <Route path="/sign-in" element={<SignIn />} />
                            <Route path="/sign-up" element={<SignUp />} />
                            <Route path="/account-verification" element={<VerifyAccount />} />
                            <Route path="/auth/email-verified-callback" element={<EmailVerified />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/update-password" element={<UpdatePassword />} />
                            <Route path="/question-generator" element={<CategoryQuestGenerator />} />
                            <Route 
                                path="/dashboard" 
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                } 
                            />
                            <Route 
                                path="/category/:categorySlug" 
                                element={
                                    <ProtectedRoute>
                                        <UserCategoryThreads />
                                    </ProtectedRoute>
                                } 
                            />
                            <Route path="/" element={<Navigate to="/sign-in" />} />

                            {/* Admin Dashboard */}
                            <Route 
                                path="/admin/dashboard" 
                                element={
                                    <AdminProtectedRoute>
                                        <AdminDashboard />
                                    </AdminProtectedRoute>
                                } 
                            />
                            {/* Coaching Categories */}
                            <Route 
                                path="/admin/coaching-categories" 
                                element={
                                    <AdminProtectedRoute>
                                        <AdminCoachingCategories />
                                    </AdminProtectedRoute>
                                } 
                            />
                            {/* Common Questions */}
                            <Route 
                                path="/admin/common-questions" 
                                element={
                                    <AdminProtectedRoute>
                                        <AdminCommonQuestions />
                                    </AdminProtectedRoute>
                                } 
                            />

                            {/* ARI Instructions */}
                            <Route 
                                path="/admin/ari-instructions" 
                                element={
                                    <AdminProtectedRoute>
                                        <AdminAriInstructions />
                                    </AdminProtectedRoute>
                                } 
                            />

                            {/* Admin Lists */}
                            <Route 
                                path="/admin/administrators" 
                                element={
                                    <AdminProtectedRoute>
                                        <AdminLists />
                                    </AdminProtectedRoute>
                                } 
                            />
                            {/* Subscribers */}
                            <Route 
                                path="/admin/subscribers" 
                                element={
                                    <AdminProtectedRoute>
                                        <AdminSubscribers />
                                    </AdminProtectedRoute>
                                } 
                            />

                            {/* =================== 404 PAGE ===================== */}
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </div>
                </AuthProvider>
            </Router>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </>
    );
}

export default App;